// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditPanel_wrapper__3mDgU"};